import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';

interface Response extends BackendResponse {}

interface Payload {
  id: number|string;
  meta_header: string;
  files: any;
}

export function useReLoanProgramAction(id: number|string, meta_header: string, files: any) {
  return useMutation({
    mutationFn: ({id, meta_header}: Payload) =>
      reExecuteLoanProgramAction({id: id, meta_header: meta_header, files: files}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just executed check.`),
        );
      }
      
      queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${id}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function reExecuteLoanProgramAction({
  id, meta_header, files
}: Payload): Promise<Response> {
  return apiClient
    .post(`loan-products/${id}/loan-program-update`, FilePayloadToFormData({meta_header: meta_header, files: files}), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(r => r.data);
}


export function FilePayloadToFormData(
  payload: Partial<Payload>,
  ) {
    const formData = new FormData();
    if (payload.meta_header) {
      formData.append("meta_header", payload.meta_header);
    }
    if (payload.files) {
        if (payload.files) {
          // payload.files.forEach((file: any) => {
          formData.append("files", payload.files);
          // });
        }
    }
  
    return formData;
  }
  
